var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('SignaturesList',{attrs:{"loading":_vm.loading,"signaturesMax":_vm.signaturesMax,"signaturesUsed":_vm.signaturesUsed}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }